<template>
    <data-table
        :customizeTable="{
            labelLoading: 'Chargement...',
            labelDetails: ''
        }"
        :loading="loading"
        :data="subscriptions"
        :headers="columns">
        <template #withPerPage>
            <with-per-page
                :customizeTable="{
                    labelShowing: '',
                    labelEntries: '',
                    entries: [10, 15, 20, 25, 30],
                }"
                @makeSelected="makeSelected($event)"
            />
        </template>

        <template #withPagination>
            <with-pagination
                @previous="previous()"
                @next="next()"
                :links="links"
            />
        </template>
        <template #withBody>
            <tr v-for="(item, i) in subscriptions" :key="i" @click="$router('intGestsouscriptions/show/'+item.uuid)" style="cursor:pointer">
                <td>{{ item.id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.product }}</td>
                <td>{{ $format(item.amount) }}</td>
                <td>{{ item.treat_name }}</td>
                <td>{{ item.created_at }}</td>
                <td>
                    <span v-if="item.status === 'add'" class="badge badge-pill badge-info">Paiement à la livraison</span>
                    <span v-if="item.status === 'negotiated' && item.amount_negotiated !== null" class="badge badge-pill badge-info">Négocié</span>
                    <span v-if="item.status === 'paid'" class="badge badge-pill badge-success">Payé</span>
                    <span v-if="item.status === 'negotiated' && item.amount_negotiated === null" class="badge badge-pill badge-info">En négociation</span>
                </td>
            </tr>
        </template>
    </data-table>
</template>

<script>
    import WithPerPage from "../../../../components/customTable/elements/withPerPage";
    import WithSearch from "../../../../components/customTable/elements/withSearch";
    import WithPagination from "../../../../components/customTable/elements/withPagination";
    import DataTable from "../../../../components/customTable/dataTable";
    import axios from "axios";
    import {api, _buildQuery } from "../../../../helpers/shared";

    const default_customize = {
        labelShowing: 'Show',
        labelEntries: 'entries',
        entries: [10, 15, 20, 25, 30],
        labelSearch: 'Search',
        labelLoading: 'Loading...',
        labelDetails: 'Showing 0 to 0 of 0 entries'
    };

    export default {
        name: "allSubscription",
        components: {WithPerPage, WithSearch, WithPagination, DataTable},
        props: ['content'],
        data: () => ({
            columns: [
                {title: 'id', key: 'reference'},
                {title: 'client', key: 'name'},
                {title: 'produit', key: 'product'},
                {title: 'montant(Fcfa)', key: 'amount'},
                {title: 'traité par', key: 'treat_name'},
                {title: 'date', key: 'created_at'},
                {title: 'statut', key: 'status'},
            ],
            loading: false,
            links: [],
            subscriptions: [],
            query:{
                page: 1,
                per: 10,
                namespace: 'all',
                product: ''
            }
        }),
        mounted() {
            //console.log("The First:",this.content )
            this.subscriptions = [ ...this.content.data ];
            //console.log("Valeur de intermediare_subscription dans AllSubscription:", this.subscriptions)
        },
        methods:{

            makeFilter(query){
                this.query = { ...query };
                this.loading = true;
                axios.get(api('load-intGest-subscription'+_buildQuery(this.query)))
                    .then((response) => {
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },

            makeSelected(val){
                this.loading = true;
                this.query.per = val;
                axios.get(api('load-intGest-subscription'+_buildQuery(this.query)))
                    .then((response) => {
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },
        }
    }
</script>

<style scoped>

</style>
